import { render, staticRenderFns } from "./MovingImagesOnImageInputAnswerForm.vue?vue&type=template&id=86de9bca&scoped=true&"
import script from "./MovingImagesOnImageInputAnswerForm.vue?vue&type=script&lang=js&"
export * from "./MovingImagesOnImageInputAnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./MovingImagesOnImageInputAnswerForm.vue?vue&type=style&index=0&id=86de9bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86de9bca",
  null
  
)

export default component.exports